<template>
  <div class="forum">
    <v-container>
      <div class="d-flex align-center mb-5">
        <h1>Salary</h1>
        <v-btn :loading="loading" @click="syncBillingThisMonth">Sync billing</v-btn>
      </div>

      <v-data-table
        :headers="headers"
        :items="data"
        class="elevation-1"
        :loading="loading"
        :items-per-page="-1"
      >
        <!-- <template v-slot:item.is_paid="{ item }">
          <v-btn color="warning" icon @click="toggleIsPaid(item)">
            <v-icon
              color="error"
              small
            >
              mdi-currency-usd
            </v-icon>
          </v-btn>
        </template> -->
        <template v-slot:item.name="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:item.bill_2="{ item }">
          <template v-if="item.bills[0]">
            <div class="d-flex flex-column align-start">
              <span class="my-3 font-weight-bold">
                {{ format(item.bills[0].date) }} - ${{ Number(item.bills[0].amount).toFixed(2) }}
              </span>
              <v-btn class="mb-3" :loading="loading" @click="generateInvoice(item.bills[0])" small>
                Generate invoice
              </v-btn>
              <v-btn 
                class="mb-3" 
                :loading="loading" 
                v-if="item.bills[0].invoice" 
                @click="sendInvoice(item.bills[0])" 
                small
                :color="item.bills[0].invoiced ? 'success' : 'error'"
                disabled
              >
                Send invoice
              </v-btn>
              <v-btn target="_blank" class="mb-3" :href="item.bills[0].invoice.pdf_url" v-if="item.bills[0].invoice" small>
                See invoice
              </v-btn>
            </div>
          </template>
          <template v-else>
            -
          </template>
        </template>
        <template v-slot:item.bill_1="{ item }">
          <template v-if="item.bills[1]">
            <div class="d-flex flex-column align-start">
              <span class="my-3 font-weight-bold">
                {{ format(item.bills[1].date) }} - ${{ Number(item.bills[1].amount).toFixed(2) }}
              </span>
              <v-btn class="mb-3" :loading="loading" @click="generateInvoice(item.bills[1])" small>
                Generate invoice
              </v-btn>
              <v-btn 
                class="mb-3" 
                :loading="loading" 
                v-if="item.bills[1].invoice" 
                @click="sendInvoice(item.bills[1])" 
                small
                :color="item.bills[1].invoiced ? 'success' : 'error'"
              >
                Send invoice
              </v-btn>
              <v-btn target="_blank" class="mb-3" :href="item.bills[1].invoice.pdf_url" v-if="item.bills[1].invoice" small>
                See invoice
              </v-btn>
            </div>
          </template>
          <template v-else>
            -
          </template>
        </template>
        <template v-slot:item.techs="{ item }">
          <v-card v-if="item.techs.filter(n => n.core).length" flat class="d-flex pa-2 ma-2 black flex-column align-start">
            <v-chip 
              small 
              color="accent" 
              class="black--text font-weight-bold mb-1" 
              v-for="n in item.techs.filter(n => n.core).map(n => n.name)"
            >
              {{ n }}
            </v-chip>
          </v-card>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn color="error" icon @click="remove(item)">
            <v-icon
              color="error"
              small
            >
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>

  </div>
</template>

<script>
import { DevsAPI } from '@/api';
// import SingleDev from '@/components/single-dev/SingleDev';
import { mapGetters } from 'vuex'
import Moment from 'moment'

export default {
  data() {
    return {
      loading: false,
      headers: [
        { text: 'Dev', value: 'pub_id' },
        { text: 'Actions', value: 'actions' },
      ],
    }
  },
  components: {
    // SingleDev,
  },
  methods: {
    sync() {
      this.loading = true;
      return this.$store.dispatch('salary/updateData')
        .finally(() => {
          this.loading = false;
        })
    },

    sendInvoice(mbill) {
      this.loading = true;
      return ClientsAPI.sendInvoice(mbill._id)
        .then(() => this.sync())
        .finally(() => {
          this.loading = false;
        })
    },

    toggleIsPaid(item) {

      if(!item.bills[1]) {
        return;
      }

      this.loading = true;
      return ClientsAPI.setIsPaid(item._id, !item.bills[1].is_paid)
        .then(() => this.sync())
        .finally(() => {
          this.loading = false;
        })
    },

    syncBillingThisMonth() {
      this.loading = true;
      return DevsAPI.syncBillingThisMonth()
        .then(() => this.sync())
        .finally(() => {
          this.loading = false;
        })
    },

    format(str) {
      return Moment(str).format('MMM')
    },
  },

  created() {
    this.sync();
  },

  computed: {
    ...mapGetters({
      data: 'salary/data',
    }),
  },
}
</script>

<style lang="scss" scoped>

.devs {
  
}

</style>